import moment from 'moment'

const AMSTERDAM_TIME_ZONE = 'Europe/Amsterdam'

interface KedoLocaleAccessor {
    env: () => {
        getSelectedLocale: () => { code?: string } | null
    }
}

export const getDateTimeLocale = (kedo: KedoLocaleAccessor): string => {
    const locale = kedo.env().getSelectedLocale()

    return locale?.code ? locale.code.replace('_', '-') : 'en'
}

export const formatDateTimeValue = (
    value: string,
    locale: string,
    withTime: boolean
): string | null => {
    if (!value) return null

    const date = moment(value)

    if (!withTime) {
        date.hours(0).minutes(0).seconds(0).milliseconds(0)
    }

    try {
        return new Intl.DateTimeFormat(locale, {
            dateStyle: 'medium',
            ...(withTime ? { timeStyle: 'medium' as const } : {}),
            timeZone: AMSTERDAM_TIME_ZONE,
        }).format(date.toDate())
    } catch {
        return null
    }
}
